var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.richTextHtml)?_c('div',{staticClass:"Component rich-text",domProps:{"innerHTML":_vm._s(_vm.richTextHtml)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }